import { FilePreview } from '../../../../../../shared/file-preview/file-preview';
import { Descriptions, Grid, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import {
  ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment,
  IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction
} from '../../../../../../../generated';
import { DATE_FORMAT } from '../../../../../../../constants';
import { TransactionData, TransactionsLite } from '../../../../../../shared/transactions/transactions-lite';
import { CertificationByApplicantLegalDisclaimer } from '../../../../components/certification-by-applicant-legal-disclaimer';
import { useNavigate } from 'react-router-dom';
import utc from 'dayjs/plugin/utc';
import { BackButton } from '../../../../../../shared/back-button';
dayjs.extend(utc);

const { Title } = Typography;

interface SummaryProps {
  data: ApplicantIdentityVerificationArchiveSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment;
}
const formatDate = (date: string) => {
  return dayjs(date).utc().format(DATE_FORMAT).toUpperCase();
};

export const Summary: React.FC<SummaryProps> = (props) => {
  const navigate = useNavigate();

  // calculate total amount
  let totalSentAmount = 0;
  let totalReceivedAmount = 0;
  if (props.data?.financeDetails?.transactions) {
    const finance = props.data?.financeDetails?.transactions ?? null;
    if (finance) {
      if (finance?.adhocTransactions?.length) {
        finance?.adhocTransactions?.forEach((transaction) => {
          const amount = transaction?.amount;
          if (amount !== undefined && amount !== null) {
            if (amount > 0) {
              totalSentAmount += amount;
            } else if (amount < 0) {
              totalReceivedAmount += Math.abs(amount); // Add to total received if negative
            }
          }
        });
      }
      if (finance?.submission) {
        const submissionAmount = finance?.submission?.amount ?? 0;
        totalSentAmount += submissionAmount;
      }
    }
  }
  const submissionTransaction: IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction = {
    amount: props.data?.financeDetails?.transactions?.submission?.amount ?? undefined,
    reason: `US$${props.data?.financeDetails?.transactions?.submission?.amount} - Request for Profile Creation and Identity Verification`,
    createdAt: props.data?.financeDetails?.transactions?.submission?.transactionReference?.completedAt,
    transactionReference: {
      referenceId: props.data?.financeDetails?.transactions?.submission?.transactionReference?.referenceId
    },
    id: props.data.id
  };

  const transactionData: TransactionData = {
    totalReceived: totalReceivedAmount,
    totalSent: totalSentAmount,
    transactionsData: [
      ...(props.data?.financeDetails?.transactions?.adhocTransactions as IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction[]),
      submissionTransaction
    ]
  };
  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;
  return (
    <div className="flex flex-col space-y-7 w-full">
      {isMobile && <BackButton onBack={() => navigate('/applicant/cases')} title="Back to Cases" />}

      <div style={{ marginTop: "20px" }}>
        <Title level={4} style={{ display: 'inline' }}>
          Identity Verification Request
        </Title>
      </div>
      <Descriptions className="mt-4" layout="vertical">
        <Descriptions.Item label="Submission Date">{formatDate(props.data.submittedAt)}</Descriptions.Item>
        <Descriptions.Item label="Decision Date">{formatDate(props.data.caseDetails.applicationReview.decision.completedAt)}</Descriptions.Item>
        <Descriptions.Item label="Case ID">{props.data.id}</Descriptions.Item>
        <Descriptions.Item label="Decision">{props.data.caseDetails.applicationReview.decision.result}</Descriptions.Item>
      </Descriptions>

      <div>
        <CertificationByApplicantLegalDisclaimer completed={true} />
      </div>

      <Title level={5}>Files</Title>
      <div className="flex w-full gap-5 flex-wrap h-auto">
        {props.data.files
          ?.filter((file) => !file?.name?.endsWith('.json'))
          .map((file) => <FilePreview key={file?.name} fileUrl={file?.url ?? ''} fileName={file?.name?.split('/').pop() ?? ''} fileType={file?.type ?? ''} />)}
      </div>
      <div>
        <TransactionsLite data={transactionData} />
      </div>
    </div>
  );
};
